import { render } from "./SettingsParent.vue?vue&type=template&id=049be691&scoped=true&ts=true"
import script from "./SettingsParent.vue?vue&type=script&lang=ts"
export * from "./SettingsParent.vue?vue&type=script&lang=ts"

import "./SettingsParent.vue?vue&type=style&index=0&id=049be691&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049be691"]])

export default __exports__